<template>
    <router-link 
        @click="emitClick"
        v-if="isVueRoute"
        :to=link 
        :class=classes 
        target="_parent">
        <slot></slot>
    </router-link>

    <a v-else
        @click="emitClick"
        :href=link 
        :class=classes 
        target="_parent">
        <slot></slot>
    </a>
</template>


<script>
export default {
    props: ['link', 'isVueRoute', 'classes'],
    methods: {
        emitClick(evt) {
            this.$emit('click', evt);
        }
    }
}
</script>

<style lang="scss">
   @import 'globalStyles';
</style>



// WEBPACK FOOTER //
// src/components/header/NavigationRoute.vue